import { useCallback } from 'react';
import { getCookie } from '@pv/common/utils';
const HUBSPOT_FORMS_API_V3_URL =
  'https://api.hsforms.com/submissions/v3/integration/submit';

/**
 * Submit a form to HubSpot
 * @param portalId - The HubSpot portal ID
 * @param formId - The HubSpot form ID
 * @returns A function that submits the form
 */
export const useSubmitHubspotForm = <T extends Record<string, string>>(
  portalId: string,
  formId: string
) => {
  const submitForm = useCallback(
    (fields: T) => {
      const hutk = getCookie('hubspotutk');

      const context = {
        hutk,
        pageUri: window.location.href,
        pageName: document.title,
      };

      fetch(`${HUBSPOT_FORMS_API_V3_URL}/${portalId}/${formId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          submittedAt: Date.now(),
          fields: Object.entries(fields).map(([key, value]) => ({
            name: key,
            value: value ?? '',
          })),
          context,
        }),
      }).catch((err) => {
        console.warn('HubSpot tracking failed:', err);
      });
    },
    [formId, portalId]
  );

  return submitForm;
};
